/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostImpactByDimensionGroupWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostImpactByDimensionGroupWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostImpactByDimensionGroupWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostImpactByDimensionGroupWidgetConfiguration>): CostImpactByDimensionGroupWidgetConfiguration {
        let obj = Object.assign(new CostImpactByDimensionGroupWidgetConfiguration(), model);
        CostImpactByDimensionGroupWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostImpactByDimensionGroupWidgetConfiguration>): CostImpactByDimensionGroupWidgetConfiguration {
        if (!model) return null;
        return CostImpactByDimensionGroupWidgetConfiguration.newInstance(<CostImpactByDimensionGroupWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostImpactByDimensionGroupWidgetConfiguration) {
        if (!obj) return;

        models.CostImpactByDimensionGroupWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostImpactByDimensionGroupWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostImpactByDimensionGroupWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
